import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Login from "./Login";
import CreateBill from "./CreateBill";
import Auth from "./Auth";
import Bill from "./Bill";
import Tranfer from "./Tranfer";
import Report from "./Report";
import NewBill from "./NewBill";
import Repository from "./Repository";
import Delivery from "./Delivery";
import BillReport from "./BillReport";
import Recept from "./Recept";
import Pay from "./Pay";
import PrintDelivery from "./PrintDelivery";

function App() {
  return (
    <div>
      <Router>
        <Route
          path={`${process.env.PUBLIC_URL}/`}
          exact
          component={(props) => <CreateBill {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/login`}
          exact
          component={() => <Login />}
        />

        <Route
          path={`${process.env.PUBLIC_URL}/report`}
          exact
          component={() => <Report />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/auth`}
          exact
          component={() => <Auth />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/create`}
          exact
          component={(props) => <CreateBill {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/replace/:bill_id`}
          exact
          component={(props) => <CreateBill {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/newbill/:id`}
          exact
          component={(props) => <NewBill {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/tranfer/:id`}
          exact
          component={(props) => <Tranfer {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pay/:id`}
          exact
          component={(props) => <Pay {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/bill/:no`}
          exact
          component={(props) => <Bill {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/bill/:no/:otp`}
          exact
          component={(props) => <Bill {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/repository`}
          exact
          component={(props) => <Repository {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/delivery`}
          exact
          component={(props) => <Delivery {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/receipt`}
          exact
          component={(props) => <Recept {...props} />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/report/bill`}
          exact
          component={(props) => <BillReport {...props} />}
        />

        <Route
          path={`${process.env.PUBLIC_URL}/print/delevery`}
          exact
          component={(props) => <PrintDelivery {...props} />}
        />
      </Router>
      <iframe
        name="printFrame"
        id="printFrame"
        title="printFrame"
        style={{ width: "0px", height: "0px", border: "none" }}
      ></iframe>
    </div>
  );
}

export default App;
